<template>
  <div class="chart chart-move" >
    <!-- <v-layout v-if="editMode" class="chart-tool">
      <v-flex row>
        <v-spacer></v-spacer>
        <v-btn
          flat
          icon
          dark
          slot="activator"
          v-scroll-to="'#down'"
          @click="$emit('duplicate-chart', slice)"
        >
          <v-tooltip bottom>
            <v-icon small slot="activator">file_copy</v-icon>
            <span>Duplicate Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('edit-chart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">build</v-icon>
            <span>Edit Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('deleteChart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">remove_circle_outline</v-icon>
            <span>Delete Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-layout v-if="editMode" class="chart-tool" >
      <v-spacer />
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
      >
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" style="outline: none;" @click="action">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile @click="$emit('duplicate-chart', slice)" v-scroll-to="'#down'" >
              <v-icon size="16" style="color: #757575;">file_copy</v-icon>
              <v-list-tile-title style=" margin-left: 5px; color: #757575;">Duplicate</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('edit-chart', chartId)" >
              <v-icon size="16" style="color: #757575;">build</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Edit</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('deleteChart', chartId)" >
              <v-icon size="16" style="color: #757575;">remove_circle_outline</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Delete</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
    </v-layout>
    <v-layout v-else-if="previewMode === true" mx-0 my-1>
    </v-layout>
    <v-layout v-else class="extand-chart" >
      <v-flex row >
        <v-spacer></v-spacer>
        <v-btn
          flat
          icon
          dark
          style="outline: none;"
          slot="activator"
          class="btn-zoom-chart"
          @click="$emit('full-chart', chartId)"
        >
          <v-tooltip bottom>
            <v-icon slot="activator">zoom_in</v-icon>
            <span>Full Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout>
    <p v-if="host">
      <font size="3" color="#f0ffff" style="margin-top: 50px;">{{host}}</font>
      <!-- <sup>
        <font size="2" color="#C17F3F" style="margin-top: 50px;">BETA</font>
      </sup> -->
    </p>
    <v-chart
      ref="options"
      :init-options="initOptions"
      :options="options"
      :autoresize="true"
      :style="{ height, width }"
      @init="initChart"
      @click="handleChartClick"
      @mouseover="ipLookup"
    ></v-chart>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/visualMap'
import 'echarts/map/js/world'
import axios from 'axios'
import echarts from 'echarts'

export default {
  name: 'TopPie',
  components: {
    'v-chart': ECharts
  },
  props: {
    text: {
      type: String
    },
    className: {
      type: String,
      default: 'chart'
    },
    user_index: {
      type: String
    },
    user_inst: {
      type: String
    },
    startTime: {
      type: [String, Number]
    },
    endTime: {
      type: [String, Number]
    },
    topLimit: {
      type: Number,
      default: 10
    },
    field: {
      type: String
    },
    orderby: {
      type: String,
      default: '_count'
    },
    fieldsum: {
      type: String,
      default: ''
    },
    stores: {
      type: Array
    },
    subFilter: {
      type: String
    },
    valid: {
      type: Boolean
    },
    chartId: {
      type: String
    },
    chartName: {
      type: String,
      default: 'Untitle'
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '90%'
    },
    editMode: {
      type: Boolean,
      default: false
    },
    previewMode: {
      type: Boolean,
      default: false
    },
    slice: {
      type: [Object]
    },
    index_now: {
      type: String
    },
    reloadchart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      x: [],
      y: [],
      key: '*',
      filter: '',
      initOptions: { renderer: 'canvas' },
      options: {},
      chartData: [],
      sub: '',
      host: ''
    }
  },
  async created () {
    if (!this.user_index) {
      this.user_index = this.index_now
    }
  },
  async mounted () {
    await this.initChart()
    await this.beforeload()
  },
  methods: {
    async ipLookup (ip) {
      let response
      if (
        ip.name.match(
          /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/
        )
      ) {
        response = await axios.post(apiUrl + '/api/status/nslookup', {
          ip: ip.name
        })
      } else {
      }
      this.host = response.data.host
    },
    async initChart () {
      this.$refs.options.showLoading({
        color: '#4ea397',
        maskColor: 'transparent',
        textColor: '#ccc'
      })
      if (this.subFilter !== '*' && this.text !== '') {
        this.sub = ''
        this.sub = `${this.subFilter} AND ${this.text}`
      } else if (this.subFilter !== '*') {
        this.sub = ''
        this.sub = `${this.subFilter}`
      } else {
      }
      let response = await axios.post(apiUrl + '/api/query/prop', {
        start: this.startTime,
        end: this.endTime,
        instance: this.user_inst,
        index: this.user_index,
        field: this.field,
        fieldsum: this.fieldsum,
        orderby: this.orderby,
        stores: this.stores,
        sub: this.sub,
        limit: this.topLimit,
        text: this.text
      })
      // console.log('response x -pie: ', response.data)
      let min = Infinity
      let max = 0
      let i
      for (i = 0; i < response.data.length; i++) {
        if (min > response.data[i].doc_count) {
          min = response.data[i].doc_count
        }
      }
      for (i = 0; i < response.data.length; i++) {
        if (max < response.data[i].doc_count) {
          max = response.data[i].doc_count
        }
      }
      this.$refs.options.hideLoading()
      // console.log('response.data x-pie')
      // console.log(response)
      // if (response.data.msg) {
      //   this.options = {
      //     title: {
      //       show: true,
      //       text: this.chartName,
      //       textStyle: {
      //         color: '#ccc',
      //         fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
      //       }
      //     },
      //     backgroundColor: 'transparent',
      //     graphic: {
      //       type: 'text',
      //       left: 'center',
      //       top: 'middle',
      //       style: {
      //         text: 'Request time out.',
      //         font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
      //         fill: '#ccc'
      //       }
      //     },
      //     series: []
      //   }
      //   return
      // }
      this.chartData = []
      for (i = 0; i < response.data.length; i++) {
        let temp = {
          name: '',
          value: 0
        }
        temp.name = response.data[i].key
        temp.value = response.data[i].doc_count
        this.chartData.push(temp)
      }
      if (Array.isArray(this.chartData) && this.chartData.length) {
        this.options = {
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)'
          },
          calculable: true,
          // toolbox: {
          //   show: true,
          //   orient: 'horizontal',
          //   itemSize: 18,
          //   itemGap: 20,
          //   right: 20,
          //   feature: {
          //     saveAsImage: {
          //       show: true,
          //       title: 'save as image'
          //     }
          //   }
          // },
          visualMap: {
            show: false,
            min: min,
            max: max,
            inRange: {
              color: ['#194682', '#4AAAF6']
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['30%', '55%'],
              center: ['50%', '60%'],
              data: this.chartData,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0,
                      color: '#5c53de'
                    },
                    {
                      offset: 1,
                      color: '#18c8ff'
                    }
                  ])
                }
              },
              label: {
                normal: {
                  textStyle: {
                    color: '#ccc'
                  }
                }
              }
            }
          ]
        }
      } else {
        this.options = {
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          backgroundColor: 'transparent',
          graphic: {
            type: 'text',
            left: 'center',
            top: 'middle',
            style: {
              text: 'No data',
              font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
              fill: '#ccc'
            }
          },
          series: []
        }
      }
    },
    beforeload () {
      this.$emit('loadChart', 'load', 'x-pie')
    },
    handleChartClick (param) {
      this.startTime = this.startTime
      this.endTime = this.endTime
      this.key = param.name
      this.field = this.field
      this.$emit('setkey', this.startTime, this.endTime, this.key, this.field)
    },
    action () {
      this.$emit('actionToChart')
    }
  },
  watch: {
    startTime: {
      handler: function (startTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    endTime: {
      handler: function (endTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    stores: {
      handler: function (stores) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    text: {
      handler: function (text) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    user_index: {
      handler: function (user_index) {
        if (this.user_index) {
          this.options = {}
          this.initChart()
        }
      }
    },
    index_now: {
      handler: function (user_index) {
        console.log(user_index)
        this.user_index = this.index_now
      }
    },
    reloadchart: {
      handler: function (val) {
        this.options = {}
        this.initChart()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* .chart {
  min-height: 250px
} */
</style>



// WEBPACK FOOTER //
// src/components/x-pie.vue